export type VideoMetadata = {
  title?: string;
  thumbnail_url?: string;
  thumbnail_width?: number;
  thumbnail_height?: number;
};

export const isVideoMetadata = (obj: unknown): obj is VideoMetadata => {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    ((obj as VideoMetadata).title !== undefined ||
      (obj as VideoMetadata).thumbnail_url !== undefined ||
      (obj as VideoMetadata).thumbnail_width !== undefined ||
      (obj as VideoMetadata).thumbnail_height !== undefined)
  );
};
